function Footer() {
  return (
    <div className="container-fluid mt-5 mb-3">
      <hr />
      <div className="d-flex">
        <div>
          <div className="copyright text-dark">
            Copyright © 2021 Sarai React - Hack For Good KENDO UI
          </div>
        </div>
      </div>
    </div>
  );
}

export default Footer;
